import EmailAddress from "common/values/email-address/email-address";
import Guid from "common/values/guid/guid";
import Name from "common/values/name/name";
import Individual from "marketplace/entities/individual/individual";
import IndividualProfile from "marketplace/values/individual-profile/individual-profile";

export interface IUserCoworker {
    id?: Guid;
    memberId: Guid;
    entityId: Guid;
    entityName: string;
    userId: Guid;
    email: string;
    firstName: string;
    lastName: string;
    individualId: Guid;
    avatarId?: Guid;
}

export default class UserCoworker {
    id?: Guid;
    memberId: Guid;
    entityId: Guid;
    entityName: string;
    userId: Guid;
    email: EmailAddress;
    name: Name
    individualId: Guid;
    avatarId?: Guid;

    constructor(coworker: Readonly<IUserCoworker>) {
        this.id = coworker.memberId;    // The Identifiable required id to be set
        this.memberId = coworker.memberId;
        this.entityId = coworker.entityId;
        this.entityName = coworker.entityName;
        this.userId = coworker.userId;
        this.email = new EmailAddress(coworker.email);
        this.name = new Name(coworker.firstName, coworker.lastName);
        this.individualId = coworker.individualId;
        this.avatarId = coworker.avatarId;
    }

     public asIndividual(): Individual {
        if (!this.individualId) {
              throw new Error(`individualId is required.`);
            }
            if (!this.entityId) {
              throw new Error(`entityId is required`);
            }
            const profile = new IndividualProfile(
              this.userId, 
              this.name.firstName ?? "", 
              this.name.lastName ?? "", 
              true
            );
            profile.entityId = this.entityId;
            profile.email = this.email;
            profile.avatarId = this.avatarId;
            return new Individual(this.individualId, this.userId, profile);
    }
}